export const roundTo = (value: number | undefined, decimals: number = 0): number | undefined => {
    if (value === undefined) {
        return undefined;
    }
    const factor = Math.pow(10, decimals);
    return Math.round((value + Number.EPSILON) * factor) / factor;
};
